import styled from 'styled-components';

interface infoProps {
  vertical?: boolean;
}

export default styled.div<infoProps>`
  text-align: center;
  font-size: 18px;
  flex: 1;
  align-items: center;
  display: ${(props) => (props.vertical ? 'flex' : 'block')};
  flex-direction: ${(props) => props.vertical && 'column'};
  justify-content: ${(props) => props.vertical && 'space-between'};

  .header {
    display: block;
  }

  .info {
    display: grid;
    grid-template-columns: 1fr;
    text-align: left;
    padding-top: 20px;

    .title {
      font-weight: bold;
    }

    .description {
      font-weight: normal;
      font-size: 16px;
    }
  }

  .reload {
    .title {
      text-align: center;
      padding-bottom: 10px;
    }
    .description {
      padding-bottom: 10px;
    }
  }
  .actionsReload {
    display: flex;
    column-gap: 12px;
  }

  .header,
  .row {
    display: grid;
    grid-template-columns: 1fr 4.5fr;
    gap: 0 0;
    border: 1px solid gray;
  }

  .header {
    font-weight: bold;
  }
  .header > div:nth-child(1),
  .row > div:nth-child(1) {
    border-right: 2px solid gray;
  }

  .row > div:nth-child(2) {
    padding-left: 4px;
    text-align: left;
    font-size: 15px;
  }

  .buttons {
    display: flex;
    justify-content: center;
    .actions {
      display: grid;
      grid-template-columns: '1fr';
      grid-gap: 25px;
      flex-direction: column;
      align-items: center;

      button {
        white-space: nowrap;
      }
    }
  }
`;
